module.exports = __webpack_public_path__ + "static/global-partners1-7f0def8cdd09639889b3cc232465ac16.jpg";